"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Input = _interopRequireDefault(require("../Input"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _constants = require("../../constants");

var _Schedule = _interopRequireDefault(require("@material-ui/icons/Schedule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const PickerWrapper = _styledComponents.default.div`
	position: relative;
	width: 155px;
`;
const StyledInput = (0, _styledComponents.default)(({
  isOpen,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_Input.default, props))`
	&.MuiInputBase-root input {
		box-shadow: ${({
  isOpen
}) => isOpen ? `${(0, _styles.fade)(_constants.colours.inputFocus, 0.25)} 0 0 0 0.2rem` : 'none'};
		border-color: ${({
  isOpen
}) => isOpen ? _constants.colours.inputFocus : _constants.colours.inputBorderColor};
	}
`;
const StyledClockIcon = (0, _styledComponents.default)(_Schedule.default)`
	position: absolute;
	right: 0;
	top: 50%;
	height: 100% !important;
	padding: 0 12px;
	cursor: pointer;
	border-left: 1px solid ${_constants.colours.inputBorderColor};
	transform: translateY(-50%);
	color: ${_constants.colours.primary};
`;
const StyledPopper = (0, _styledComponents.default)(_core.Popper)``;
const StyledPaper = (0, _styledComponents.default)(_core.Paper)`
	display: flex;
	width: 155px;
	max-height: 190px;
	overflow: auto;
`;
const Column = _styledComponents.default.ul`
	margin: 0;
	padding: 0;
	flex: 1;
	list-style: none;
	overflow-y: auto;
`;
const StyledOption = _styledComponents.default.li`
	padding: 12px;
	transition: all 0.2s ease-in-out;
	font-variant-numeric: normal;

	:hover {
		color: ${_constants.colours.black};
		background-color: ${_constants.colours.mediumGrey};
		cursor: pointer;
	}

	${props => props.isSelected && `
			color: ${_constants.colours.white};
			background-color: ${_constants.colours.blue};
		`}
`;
const defaultHours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
const defaultMins = ['00', '15', '30', '45'];

const TimePickerWrapper = ({
  value,
  hours = defaultHours,
  minutes = defaultMins,
  setHour,
  setMinute,
  label,
  required,
  error,
  ...rest
}) => {
  const [menuOpen, toggleMenu] = (0, _react.useState)(false);
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const selectedHour = value.split(':')[0];
  const selectedMinute = value.split(':')[1];

  const handleClick = event => {
    toggleMenu(true);
    const target = event.target.parentNode;

    if (target.className instanceof SVGAnimatedString) {
      setAnchorEl(target.parentNode);
    } else {
      setAnchorEl(target);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    required: required,
    error: error
  }, label), /*#__PURE__*/_react.default.createElement(PickerWrapper, null, /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    isOpen: menuOpen,
    onClick: handleClick
  }, rest, {
    value: value
  })), /*#__PURE__*/_react.default.createElement(StyledClockIcon, {
    onClick: handleClick
  }), /*#__PURE__*/_react.default.createElement(StyledPopper, {
    disablePortal: true,
    open: menuOpen,
    anchorEl: anchorEl,
    placement: "bottom-start"
  }, /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: () => toggleMenu(false)
  }, /*#__PURE__*/_react.default.createElement(StyledPaper, {
    elevation: 3,
    square: true
  }, /*#__PURE__*/_react.default.createElement(Column, null, hours.map(hr => /*#__PURE__*/_react.default.createElement(StyledOption, {
    onClick: () => setHour(hr),
    isSelected: hr === selectedHour,
    "aria-label": "Select an hour value",
    key: hr
  }, hr))), /*#__PURE__*/_react.default.createElement(Column, null, minutes.map(min => /*#__PURE__*/_react.default.createElement(StyledOption, {
    onClick: () => setMinute(min),
    isSelected: min === selectedMinute,
    "aria-label": "Select a minute value",
    key: min
  }, min))))))));
};

var _default = TimePickerWrapper;
exports.default = _default;